import { Menu, Tooltip } from '@mantine/core';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { IconUserPlus } from '@tabler/icons-react';
import { useDelegate } from 'components/modals/delegate/DelegateProvider';
import { useCallback } from 'react';
import { DelegatedUser } from 'components/modals/delegate/DelegateModal';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the users who have the permission to Delegate the revision.
 */
export default function DelegateAction({ revision, kind, onStatusChange }: RevisionSingleActionProps) {
  const { delegate } = useDelegate();

  /**
   * Opens the delegation modal.
   */
  const openDelegationModal = useCallback(() => {
    // Map delegatedTo from API response to DelegatedUser format
    const delegatedUsers: DelegatedUser[] = (revision.delegatedTo || []).map((user) => ({
      userId: user.userId,
      firstName: user.firstName,
      lastName: user.lastName,
      fullName: user.fullName,
      email: user.email,
      state: user.state as 'pending' | 'accepted' | 'rejected',
    }));

    delegate({
      title: revision.kind === 'revision' ? 'Delegovanie revíznej správy' : 'Delegovanie formulára',
      revisionKind: revision.kind,
      revisionId: revision.revisionId,
      departmentId: revision.department.departmentId,
      deviceTypeId: revision.deviceType.deviceTypeId,
      technicianId: revision.technician!.userId,
      delegatedUsers,
      onDelegate: () => {
        // Refresh the revision data after delegation changes
        if (onStatusChange) {
          onStatusChange({
            status: revision.revisionStatus,
            revisionId: revision.revisionId,
          });
        }
      },
    });
  }, [delegate, revision, onStatusChange]);

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Delegovať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" onClick={openDelegationModal}>
          <IconUserPlus />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button size="md" onClick={openDelegationModal} leftIcon={<IconUserPlus />} variant="secondary" w={188}>
        Delegovať
      </Button>
    );
  }

  return (
    <Menu.Item onClick={openDelegationModal} icon={<IconUserPlus stroke="1.5" size={24} />} color="gray.8">
      Delegovať
    </Menu.Item>
  );
}
